<form [formGroup]="repairPartSearchTextForm">
  <div>
    <mc-input
      hiddenlabel
      placeholder="Search for Repair code or Part Code"
      fit="small"
      ngDefaultControl
      formControlName="SearchText"
      (keyup.enter)="applySearchTextFilters()"
      icon="magnifying-glass"
      [clearbutton]="true"
      (clearbuttonclick)="applySearchTextFilters()">
    </mc-input>
  </div>
</form>
